import React from 'react';
import { Card } from 'primereact/card';
import { classNames } from 'primereact/utils';
import './MetricsList.scss';
import { CardEmptyState } from '../../pages/BusinessAnalytics/components/CardEmptyState';

interface MetricsListProps<T> {
  title?: string;
  items: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
  className?: string;
  isEmpty: boolean;
  emptyStateText?: string;
}

export const MetricsList = <T,>({
  title,
  items,
  renderItem,
  className,
  isEmpty,
  emptyStateText = 'No hay datos',
}: MetricsListProps<T>) => {
  if (isEmpty || items.length === 0) {
    return (
      <Card title={title} className={classNames('metrics-list', className)}>
        <CardEmptyState text={emptyStateText} />
      </Card>
    );
  }

  return (
    <Card title={title} className={classNames('metrics-list', className)}>
      <ol className='list-container'>
        {items.map((item, index) => (
          <li key={index} className='list-item'>
            {renderItem(item, index)}
          </li>
        ))}
      </ol>
    </Card>
  );
};
